import { Box, Typography } from "@mui/material";

const TAG_LABEL_OVERRIDES = {
    NSR: "No Signature Required",
};

const EXCLUDED_KEYS = [];

export default function TagsPanel({ title, tagIcons }) {
    let tags = [];
    try {
        tags = tagIcons ? JSON.parse(tagIcons) : [];
    } catch (e) {}

    tags = tags.filter((t) => !EXCLUDED_KEYS.includes(t.textKey));

    if (!tags.length) return null;

    return (
        <Box sx={{ mt: 2.5, display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            {title ? (
                title
            ) : (
                <Typography
                    variant="caption"
                    sx={{
                        display: "block",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "text.secondary",
                        fontWeight: 600,
                        mb: 1,
                    }}
                >
                    Tags
                </Typography>
            )}
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "repeat(1, 1fr)", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
                    gap: 1,
                    width: "100%",
                }}
            >
                {tags.map((tag) => {
                    const len = tag.variableDisplayValue?.length ?? 0;
                    const colSpan = len > 180 ? 4 : len > 100 ? 3 : len > 50 ? 2 : 1;
                    return (
                        <Box
                            key={tag.mastertagID}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                p: 1,
                                border: "1px solid",
                                borderColor: tag.tagColor ? "transparent" : "divider",
                                borderRadius: 1,
                                bgcolor: tag.tagColor || "background.paper",
                                gridColumn: { xs: "span 1", sm: `span ${Math.min(colSpan, 2)}`, md: `span ${colSpan}` },
                                minWidth: 0,
                            }}
                        >
                            {tag.icon_url && (
                                <img
                                    src={tag.icon_url}
                                    alt=""
                                    style={{ width: 30, height: "auto", flexShrink: 0, marginTop: 1 }}
                                />
                            )}
                            <Box sx={{ minWidth: 0 }}>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        display: "block",
                                        fontWeight: 700,
                                        color: tag.tagTextColor || "text.primary",
                                        lineHeight: 1.2,
                                        mb: 0.25,
                                    }}
                                >
                                    {TAG_LABEL_OVERRIDES[tag.textKey] ?? tag.textKey}
                                </Typography>
                                {tag.variableDisplayValue && (
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            color: tag.tagTextColor || "text.secondary",
                                            opacity: 0.85,
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        {tag.variableDisplayValue}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
